import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { SuccessDialogComponent } from '../../common/success-dialog/success-dialog.component';
import { DashpillsComponent } from '../../common/dashpills/dashpills.component';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  form: FormGroup;
  years: number[] = [];
  formSubmitted: boolean = false;
  formSuccess: boolean = false;
  userInfo: any;

  constructor(private apiService: ApiService, private fb: FormBuilder, private dialog: MatDialog) {}

  ngOnInit(): void {
    this.initializeForm();
    this.populateYears();
    this.fetchUserInfo();
  }

  initializeForm(): void {
    this.form = this.fb.group({
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      dob: ['', Validators.required],
      sex: ['', Validators.required],
      employment_status: ['', Validators.required],
      education: this.fb.array([]),
      workExperiences: this.fb.array([])
    });
  }

  
  fetchUserInfo(): void {
    this.apiService.getUserInfo().subscribe({
      next: (info) => {
        this.form.patchValue({
          firstname: info.firstname,
          lastname: info.lastname,
          dob: info.dob,
          sex: info.sex,
          employment_status: info.employment_status,
        });
  
        this.userInfo = info;
        // Parse and populate educations
        let educations = [];
        try {
          educations = typeof info.education === 'string' ? JSON.parse(info.education) : info.education || [];
        } catch (error) {
          console.error('Error parsing education JSON:', error);
        }
  
        if (this.educationFormArray) {
          this.educationFormArray.clear();
          educations.forEach(education => {
            this.addEducation(education);
          });
      }
    
  
        // Parse and populate work experiences
        let workExperiences = [];
        try {
          workExperiences = typeof info.work_experience === 'string' ? JSON.parse(info.work_experience) : info.work_experience || [];
        } catch (error) {
          console.error('Error parsing work_experience JSON:', error);
        }
        if (  this.workExperienceFormArray) {
        this.workExperienceFormArray.clear();
        workExperiences.forEach(workExperience => {
          this.addWorkExperience(workExperience);
        });
      }
      },
      error: (error) => console.error('Error fetching user info:', error)
    });

    
  }
  
  

  get educationFormArray(): FormArray {
    return this.form.get('education') as FormArray;
  }

  get workExperienceFormArray(): FormArray {
    return this.form.get('workExperiences') as FormArray;
  }
  addEducation(education: any = {}): void {
    const educationGroup = this.fb.group({
      level: [education.level || '', Validators.required],
      institute: [education.institute || '', Validators.required],
      startYear: [education.startYear || '', Validators.required],
      endYear: [education.endYear || '', Validators.required],
      isFinished: [education.isFinished || false, Validators.required]
    });
    this.educationFormArray.push(educationGroup);
  }
  

  addWorkExperience(workExperience: any = {}): void {
    const workExperienceGroup = this.fb.group({
      company: [workExperience.company || '', Validators.required],
      position: [workExperience.position || '', Validators.required],
      startYear: [workExperience.startYear || '', Validators.required],
      endYear: [workExperience.endYear || '', Validators.required],
      isCurrent: [workExperience.isCurrent || false, Validators.required]
    });
    this.workExperienceFormArray.push(workExperienceGroup);
  }

  removeEducation(index: number): void {
    this.educationFormArray.removeAt(index);
    if (this.educationFormArray) {
      this.educationFormArray.removeAt(index);
    } else {
      console.warn('workExperienceFormArray is not yet initialized');
    }
  }

  removeWorkExperience(index: number): void {
    if (this.workExperienceFormArray) {
      this.workExperienceFormArray.removeAt(index);
    } else {
      console.warn('workExperienceFormArray is not yet initialized');
    }
  }

  populateYears(): void {
    for (let year = 1970; year <= new Date().getFullYear(); year++) {
      this.years.push(year);
    }
  }

  submitUserProfile(): void {
    this.formSubmitted = true; // Mark the form as submitted

    if (this.form.valid) {
      this.apiService.editUserProfile(this.form.value).subscribe({
        next: (response) => {
          console.log('Profile updated successfully', response);
          this.formSuccess = true; // Mark the form submission as successful
          this.openSuccessDialog(); // Open success dialog
        },
        error: (error) => {
          console.error('Error updating profile:', error);
          this.formSuccess = false;
        }
      });
    } else {
      console.error('Form is not valid', this.form.errors);
    }
  }
  openSuccessDialog(): void {
    this.dialog.open(SuccessDialogComponent, {
      width: '250px',
      data: { message: 'Profile updated successfully!' }
    });
  }
}
